import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { NCRBaseButtonProps } from 'src/common/components/base-button/base-button';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';

export const addDefaultButtons = (modalProps: IMessageModal, sharedAction = () => {}): void => {
  const { onAccept, onCancel, rightButtons, leftButtons, separateButton } = modalProps;

  const declineButton = (label: string): NCRBaseButtonProps => ({
    'data-testid': 'dialog-messages-close',
    buttonType: 'white',
    onClick: onCancel
      ? () => {
          sharedAction();
          onCancel();
        }
      : undefined,
    children: label,
  });

  const acceptButton = (label: string): NCRBaseButtonProps => ({
    'data-testid': 'dialog-messages-accept',
    buttonType: 'primary',
    onClick: onAccept
      ? () => {
          sharedAction();
          onAccept();
        }
      : sharedAction,
    children: label,
  });

  if (!rightButtons) {
    const acceptButtonDefaultLabel = modalProps.type === EmeraldDialogTypes.Info ? 'Ok' : 'Close';
    modalProps.rightButtons = [
      acceptButton(modalProps.acceptButtonLabel || acceptButtonDefaultLabel),
    ];

    if (modalProps.onCancel) {
      const defaultDeclineButton = declineButton(modalProps.closeButtonLabel || 'No');
      if (separateButton && !leftButtons) {
        modalProps.leftButtons = [defaultDeclineButton];
      } else {
        modalProps.rightButtons.unshift(defaultDeclineButton);
      }
    }
  }
};
